module.exports = function getResource(label, vars = []) {
    let resources = {
        orders: 'Commandes',
        noOrders: 'Vous n’avez pas de commande récente.',
        orderDate: 'Date de la commande',
        pickupOrder: 'Commande à ramasser',
        orderNumber: 'Numéro de commande',
        status: 'Statut',
        trackingDetails: 'Détails du suivi',
        viewDetails: 'Voir les détails',
        showMore: 'Afficher plus',
        viewAllPurchases: 'Voir tous les achats',
        replenItemsCarouselTitle: 'Réapprovisionner les achats antérieurs',
        replenItemsViewAll: 'Voir tout'
    };

    return resources[label];
};
